
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface ErrorAlertProps {
  isError: boolean;
  error: any;
  handleRefresh: () => void;
}

export const ErrorAlert = ({ isError, error, handleRefresh }: ErrorAlertProps) => {
  if (!isError) return null;

  // Extract the error message
  let errorMessage = "An unknown error occurred while fetching users.";
  
  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'object' && error !== null) {
    // Handle Supabase error object
    errorMessage = error.message || errorMessage;
  }

  return (
    <Alert variant="destructive">
      <AlertTitle>Error loading users</AlertTitle>
      <AlertDescription>
        <div className="mb-2">{errorMessage}</div>
        <div className="text-sm mb-2">
          <p>
            We've updated the RLS policy to allow access to all profiles, but if you're still 
            experiencing issues, please check your Supabase dashboard for any conflicting policies.
          </p>
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleRefresh}
        >
          Try Again
        </Button>
      </AlertDescription>
    </Alert>
  );
};
